import { HttpErrorResponse } from '@angular/common/http';
import { Logger, MasterHelper } from 'src/app/core/utilities';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AuditTrail } from './../../../core/models/user-management/audit-trail';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { AuditTrailDto } from './../../../core/models/view-model/audit-trail-dto';
import { AuditTrailModel } from './../../../core/models/view-model/audit-trail-model';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.scss']
})
export class AuditTrailComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;
  @ViewChild('tableContent', { read: ElementRef })
  public tableContent: any;
  myInnerHeight: any;

  @Input() trailType: any;

  filterPersistenceKey = 'auditTrailFilters';
  auditTrailDto: AuditTrailDto;
  auditTrailList: Array<AuditTrail>;
  isLoading = false;
  startIndex = 0;
  lastIndex = 0;
  currentPageNumber = 1;
  totalPageCount = 0;
  totalCount = 0;
  takeCount = 0;
  skipCount = 0;
  isTableLoaded = false;
  endIndex = 10;


  constructor(private userService: UserManagementService) {
    this.auditTrailDto = new AuditTrailDto();
    this.auditTrailList = [];
    this.myInnerHeight = window.innerHeight - 220;
  }

  ngOnInit(): void {
    const persistFilter = JSON.parse(MasterHelper.fetchFromBrowser(this.filterPersistenceKey) as string) as AuditTrailDto;
    if (persistFilter) {
      this.auditTrailDto = persistFilter;
    }
    this.auditTrailDto.SortKey = 'CreatedDateTime';
    this.auditTrailDto.IsDesc = true;
    this.fetchAuditTrail();
  }

  eventHandler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
  }

  fetchAuditTrail(): void {
    this.isLoading = true;
    this.auditTrailDto.auditTrailType = this.trailType;
    this.auditTrailDto.SkipCount = this.skipCount;
    this.auditTrailDto.TakeCount = this.takeCount;
    this.userService.getAuditTrail(this.auditTrailDto).subscribe((data: AuditTrailModel) => {
      this.auditTrailList = data.auditTrailList;
      this.totalCount = data.totalCount;
      this.isLoading = false;

      this.isTableLoaded = true;
      this.CalculatePageCount(this.totalCount, this.takeCount);
      this.lastIndex = this.skipCount + data.auditTrailList.length;
      this.startIndex = (this.takeCount * (this.currentPageNumber - 1)) + 1;
      this.endIndex = this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
    });
  }

  OnAction(currentPN: number): void {
    this.currentPageNumber = currentPN;
    this.skipCount = this.takeCount * (currentPN - 1);
    this.fetchAuditTrail();
  }

  CalculatePageCount(totalItems: number, takeCount: number): void {
    this.totalPageCount = parseInt((totalItems / takeCount).toString(), 10);
    if (totalItems % takeCount !== 0 && totalItems > 10) {
      this.totalPageCount = this.totalPageCount + 1;
    }
  }

  sortAuditTrail(key: string): void {
    this.auditTrailDto.IsDesc = !this.auditTrailDto.IsDesc;
    this.auditTrailDto.SortKey = key;
    this.fetchAuditTrail();
  }

  OnFilter(filter: AuditTrailDto): void {
    this.auditTrailDto = filter;
    this.fetchAuditTrail();
  }

  downloadReport(): any {
    this.isLoading = true;
    this.userService.exportAuditTrail(this.auditTrailDto).subscribe(
      (data: any) => {
        this.isLoading = false;
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `AuditTrail.xlsx`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        Logger.log(this.constructor.name, error.error);
      }
    );
  }
}
